<script lang="ts" setup>
const props = withDefaults(
  defineProps<{
    gap?: 0 | 2 | 4 | 6 | 8 | 12 | 20 | undefined
    direction?: 'row' | 'column' | undefined
    wrap?: 'wrap' | 'nowrap' | undefined
    justify?:
      | 'flex-start'
      | 'flex-end'
      | 'center'
      | 'space-between'
      | 'space-around'
      | undefined
    align?:
      | 'flex-start'
      | 'flex-end'
      | 'center'
      | 'baseline'
      | 'stretch'
      | undefined
    fillMainAxis?: boolean
  }>(),
  {
    gap: 12,
    direction: 'row',
    wrap: 'nowrap',
    justify: 'flex-start',
    align: 'stretch',
    fillMainAxis: false
  }
)

const tagClasses = computed(() => {
  return {
    'myz-flex': true,
    'myz-flex-width-fill': props.fillMainAxis && props.direction == 'row',
    'myz-flex-height-fill': props.fillMainAxis && props.direction == 'column',
    [`myz-flex-${props.direction}`]: true,
    [`myz-flex-${props.wrap}`]: true,
    [`myz-flex-justify-${props.justify}`]: true,
    [`myz-flex-align-${props.align}`]: true,
    [`myz-flex-gap-${props.gap}px`]: true
  }
})
</script>

<template>
  <div :class="tagClasses">
    <slot />
  </div>
</template>
